<template>
  <div id="app" data-v-app>
    <div style="background-color: #3f78f6">
      <van-sticky>
        <van-nav-bar
          style="background-color: #3f78f6; margin-bottom: 0rem; border: 0"
          title=""
          left-text=""
          left-arrow
          @click-left="onClickLeft"
        >
          <template #title>
            <span style="color: white; font-size: 0.4rem">学生轨迹查询</span>
          </template>
          <template #left>
            <van-icon name="arrow-left" color="white" size="18" />
          </template>
        </van-nav-bar>
        <van-search
          v-model="value"
          shape="round"
          style="margin-top: 0rem; border: 0"
          background="#3f78f6"
          right-icon="search"
          left-icon=""
          placeholder="请输入学生姓名或学号"
          @search="onSearch"
        />
      </van-sticky>
    </div>
    <!-- 内容循环操作-->
    <section class="van-doc-demo-section">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="locusItems" v-for="item in list" :key="item.id">
          <div style="font-size: 0.4rem; margin-left: 0.5rem">
            {{ item.ftime }}
          </div>
          <div>
            <h1>{{ item.fname }}</h1>
          </div>
          <van-row style="font-size: 0.4rem;margin-left: 0.5rem">
            <van-col span="18">{{ "位置：" + item.fpos }}</van-col>
            <van-col span="6">{{ "方向：" + item.inout_flag }}</van-col>
          </van-row>
        </div>
      </van-list>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      loading: false,
      code: "",
      codenum: "",
      finished: false,
      student: "",
      page: "",
      list: [],
    };
  },
  created() {
    this.student = this.$route.query.student;
    this.page = this.$route.query.page;
    console.log(
      "传递过来得学生ID：" + this.student + "和默认轮播定位：" + this.page
    );
    this.init();
  },
  methods: {
    init() {
      var json = window.localStorage.getItem("User");
      var jsonObj = JSON.parse(json);
      console.log("身份:" + jsonObj[0]["shenfen"]);
      var code;
      var codenum;
      if (jsonObj[0]["shenfen"] == "老师") {
        code = jsonObj[0]["number"];
        codenum = 0;
      } else if (jsonObj[0]["shenfen"] == "学生") {
        code = jsonObj[0]["number"];
        codenum = 2;
      } else {
        code = jsonObj[0]["phone"];
        codenum = 1;
      }
      this.code = code;
      this.codenum = codenum;
      var params_json = {
        userid: code,
        action: "trackList",
        param1: codenum,
        param2: "",
        param3: "",
        param4: "",
        param5: "",
      };

      this.$http.post("/web/list", params_json).then(function (res) {
        // let obj = res.data["rows"];
        console.log(res.data["rows"]);
        this.list = res.data["rows"];
      });
      this.onLoad();
    },
    onClickLeft() {
      this.$router.push({
        path: "Index",
        query: {
          page: this.page,
        },
      });
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= this.list.length) {
          this.finished = true;
        }
      }, 1000);
    },
    onSearch(val) {
      if (val == "") {
        this.init();
      } else {
        var params_json = {
          userid: this.code,
          action: "trackList",
          param1: this.codenum,
          param2: val,
          param3: "",
          param4: "",
          param5: "",
        };

        this.$http.post("/web/list", params_json).then(function (res) {
          // let obj = res.data["rows"];
          console.log(res.data["rows"]);
          this.list = res.data["rows"];
          this.onLoad();
        });
      }
    },
  },
};
</script>

<style>
.locusItems {
  margin-left: 0rem;
  padding: 0.3rem 0;
  border-bottom: 0.2rem solid #eaeaea;
  position: relative;
}

ul.areaUi {
  height: 0.3rem;
  margin: 0 0 0.2rem 0.2rem;
}

ul.areaUi li {
  float: left;
  margin-right: 0.1rem;
}

.locusItems h1 {
  font-size: 0.4rem;
  font-weight: bold;
  margin: 0 0 0.1rem 0.5rem;
}

.locusItems p {
  font-size: 0.4rem;
  color: #666;
  margin: 0 0 0.1rem 0.5rem;
}

.locusItems span {
  font-size: 0.4em;
  color: #666;
  position: absolute;
  top: 0.3rem;
  left: 0.5rem;
}
</style>